import {Component, Injector, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {VideoDto, VideoServiceProxy} from '../../../shared/service-proxies/service-proxies';

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.less']
})

export class ShowComponent implements OnInit {

  id: number;
  src: SafeResourceUrl;
  title: string;
  constructor(injector: Injector, private _videoService: VideoServiceProxy, private sanitizer: DomSanitizer) {
    this.id = Number(location.href.substr(location.href.indexOf('=') + 1));
  }

  ngOnInit(): void {
    this._videoService.info(this.id).subscribe((result) => {
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(result.video);
      this.title = result.title;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/video/list/show.component.ts